/**
 * @generated SignedSource<<c9f67ef89530d83bd4530600f42c7a11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "ApplyResponse",
    "kind": "LinkedField",
    "name": "apply",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "feedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "feedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e00991304cc39b8ffeb4c8d572c2e3c",
    "id": null,
    "metadata": {},
    "name": "feedbackMutation",
    "operationKind": "mutation",
    "text": "mutation feedbackMutation(\n  $request: ApplyRequestInput\n) {\n  apply(request: $request) {\n    email\n  }\n}\n"
  }
};
})();

node.hash = "73cedc070e498cc0707a7c26a8c23786";

module.exports = node;
